export const mainNav = [
  {
    title: "Features",
    href: "/#features",
  },
  {
    title: "AI Agents",
    href: "/#ai-agents",
  },
  {
    title: "Pricing",
    href: "/#pricing",
  },
] as const;

export const footerNav = [
  {
    title: "MCP Docs",
    href: "/docs/mcp",
  },
  {
    title: "Terms",
    href: "/terms",
  },
  {
    title: "Privacy",
    href: "/privacy",
  },
] as const;
